import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ui-rounded-panel',
  templateUrl: './ui-rounded-panel.component.html',
  styleUrls: ['./ui-rounded-panel.component.scss']
})
export class UiRoundedPanelComponent {
  @Input() fillBackground: boolean;
}
